import script from "./CResultGameInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./CResultGameInfo.vue?vue&type=script&setup=true&lang=ts"

import "./CResultGameInfo.vue?vue&type=style&index=0&id=1c121352&lang=less"

const __exports__ = script;

export default __exports__